module.exports = __webpack_public_path__ + "img/[坏笑].18017a7a.svg";